module.exports = __webpack_public_path__ + "media/images/icons/outlined/left-6ad01f55a73f916b870f10c531ec544a.svg";